export const mobileTopup = [
  { value: '300', label: '300 RSD' },
  { value: '500', label: '500 RSD' },
  { value: '700', label: '700 RSD' },
  { value: '1000', label: '1.000 RSD' },
  { value: '1500', label: '1.500 RSD' },
];

export const internetTopup = [{ value: '999', label: '50GB - 999 RSD' }];

export const mobilePrefixes = [
  { value: '062', label: '062' },
  { value: '063', label: '063' },
  { value: '069', label: '069' },
  { value: '060', label: '060' },
  { value: '061', label: '061' },
  { value: '064', label: '064' },
  { value: '065', label: '065' },
  { value: '066', label: '066' },
];

export const DEFAULT_PREFIX = '063';
